import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, FormControl, FormControlLabel, FormGroup, FormLabel, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Stack, TextareaAutosize } from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmDialog from '../../common/ConfirmDialog';
import SearchField from '../../util/SearchField';
import Service from '../../../util/Service';
import { RemoveCircle } from '@mui/icons-material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];

export default function AcessoPage() {
    const [open, setOpen] = React.useState(false);
    const [openExc, setOpenExc] = React.useState(false);
    const [acessos, setAcessos] = React.useState();
    const [acesso, setAcesso] = React.useState();
    const [nome, setNome] = React.useState('');
    const [descricao, setDescricao]  = React.useState('');

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClickMenu = (event, row) => {
        setAnchorEl(event.currentTarget);
        setAcesso(row);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        buscaTodos();
    }, [])

    const handleClose = () => {
        setOpen(false);
    };
    const buscaTodos = () => {
        Service.GET("/api/acesso/findAll").then(r => setAcessos(r))
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        // const formData = new FormData(event.currentTarget);
        // const formJson = Object.fromEntries(formData.entries());
        // const email = formJson.email;
        // console.log(formJson);
        let formJson = {
            nome: nome,
            descricao: descricao
        }
        if( acesso) formJson.id = acesso.id;

        Service.POST('/api/acesso/salvar', formJson).then(r => {
            console.log(r);
            handleClose();
            buscaTodos();
            setNome( '');
            setDescricao('');
        });
    };
    function handleExcluirItem(){
        console.log( ">>handleExcluir<<")
        Service.GET("/api/security/acesso/remove/"+acesso.id).then(r => buscaTodos() );
    }
    function onSearch(e) {
        console.log(e);
    }
    function formataData(dt) {
        if (!dt) return '';
        const data = new Date(dt);
        let txt = data.toLocaleDateString();
        txt += " " + data.toLocaleTimeString();
        return txt;
    }
    function handleEditar(){
        handleCloseMenu();
        setOpen(true);
        console.log( acesso );
        
        setNome( acesso.nome);
        setDescricao( acesso.descricao);
    }
    function handleExcluir(){
        handleCloseMenu();
        setOpenExc(true);
    }

    function IconMenu() {
        return (
            <Menu 
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseMenu}
            >
                <Paper sx={{ width: 120, maxWidth: '100%' }}>
                <MenuList>
                    <MenuItem onClick={handleEditar}>
                        <ListItemIcon>
                            <EditIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Editar</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={handleExcluir}>
                        <ListItemIcon>
                            <RemoveCircle fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excluir</ListItemText>
                    </MenuItem>
                </MenuList>
                </Paper>
            </Menu>
        );
    }

    return (
        <React.Fragment>
            <Stack direction="row" spacing={2}>
                <SearchField handleSearch={onSearch} />
                <Button
                    variant="outlined" startIcon={<AddIcon />}
                    onClick={e => {
                        setOpen(true); 
                        setAcesso(); 
                    }}
                >
                    Nova Regra
                </Button>
            </Stack>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} size="small" >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ width: 160 }} >Nome</StyledTableCell>
                            <StyledTableCell style={{ width: 160 }} align="center" >Dt Criação</StyledTableCell>
                            <StyledTableCell>Descrição</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {acessos && acessos.map((row) => (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell component="th" scope="row">
                                    {row.nome}
                                </StyledTableCell>
                                <StyledTableCell align="center">{formataData(row.dtCriacao)}</StyledTableCell>
                                <StyledTableCell >
                                    <small>{row.descricao}</small>
                                    <IconButton 
                                        size="small" aria-label="add" style={{ float: "right" }}
                                        onClick={(e) =>handleClickMenu(e, row)}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <IconMenu />

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Novo Regra de Acesso</DialogTitle>
                <DialogContent sx={{ paddingBottom: 0 }}>
                    <DialogContentText>
                        Informe um nome de acesso unico e uma descrição da regra de acesso.
                    </DialogContentText>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            value={nome}
                            onChange={e => setNome(e.target.value)}
                            label="Nome"
                            // type="email"
                            fullWidth
                            variant="outlined"
                        />
                        <FormControl style={{ width: '100%', marginTop: 5 }}>
                            <FormLabel >Descrição</FormLabel>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={4}
                                value={descricao}
                                onChange={e => setDescricao(e.target.value)}
                                placeholder=""
                                style={{ width: '100%', marginTop: 5 }}
                            />
                        </FormControl>


                        <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button type="submit">Incluir</Button>
                        </DialogActions>

                    </form>
                </DialogContent>
            </Dialog>
            <ConfirmDialog 
                open={openExc} setOpen={setOpenExc} 
                ok='Confirma' cancel='sair' 
                title='Exclusão'
                execute={handleExcluirItem}
            >
                <div style={{ width: "438px", padding: "16px 24px" }}>
                    <p style={{ fontSize: "16px", textAlign: "left", marginLeft: -8 }}>
                        Confirma exclusão do item?
                    </p>                    
                </div>
            </ConfirmDialog>
        </React.Fragment>
    );
}
